import { render, staticRenderFns } from "./MicroeconomicsTable.vue?vue&type=template&id=0ade537b&"
import script from "./MicroeconomicsTable.vue?vue&type=script&lang=ts&"
export * from "./MicroeconomicsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports